import Location from 'entities/location/model';

import { ADD, ADD_MULTIPLE, UPDATE, REMOVE, FETCH_ALL_LOCATIONS } from './constants';

export interface FetchAllLocationsAction {
  type: typeof FETCH_ALL_LOCATIONS;
}

export const addMultipleAction: (locations: Location[]) => {
  locations: Location[];
  type: string;
} = (locations: Location[]) => ({
  type: ADD_MULTIPLE,
  locations,
});

export const fetchAllLocationsAction = (): FetchAllLocationsAction => ({
  type: FETCH_ALL_LOCATIONS,
});

export const addAction: (location: Location) => { location: Location; type: string } = (
  location: Location
) => ({
  type: ADD,
  location,
});

export const updateAction: (locations: Location[]) => { locations: Location[]; type: string } = (
  locations: Location[]
) => ({
  type: UPDATE,
  locations,
});

export const removeAction: (id: string) => { id: string; type: string } = (id: string) => ({
  type: REMOVE,
  id,
});
